<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader :title="id ? 'Update Attribute' : 'Create Attribute'" />
        <div>
          <md-button :to="{ name: 'Product Attribute' }" class="md-primary">
            Back
          </md-button>
        </div>
      </div>

      <div>
        <form novalidate class="md-layout" @submit.prevent="validateAttr">
          <md-field :class="getValidationClass('first_name')">
            <label>Title</label>
            <md-input v-model="form.title" required></md-input>
            <span class="md-error" v-if="!$v.form.title.required"
              >Title is required</span
            >
          </md-field>
          <mdc-button :loading="loading">{{
            id ? "Update Attribute" : "Create Attribute"
          }}</mdc-button>
        </form>
      </div>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("product");

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {},
    loading: false
  }),
  validations: {
    form: {
      title: {
        required
      }
    }
  },
  methods: {
    ...mapActions(["createAttr", "updateAttr", "getAttr"]),
    async validateAttr() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = { ...this.form };

        try {
          this.loading = true;
          let call = this.id ? this.updateAttr(data) : this.createAttr(data);
          let msg = this.id ? "Attribute Updated" : "Attribute Created";
          await call;
          this.toast("success", msg);
          this.$router.push({ name: "Product Attribute" });
          this.loading = false;
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.toast("error", "Opps, Something went wrong ");
        }
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getAttr(this.id).then((attribute) => {
        this.form = {
          title: attribute.title,
          id: attribute.id
        };
      });
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped lang="scss">
.feature-attributes {
  width: 100%;
  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;

    .val {
      flex: 1;
    }

    .attr {
      width: 25%;
    }
  }
}
</style>
